import React from 'react'

import { compose, withHandlers } from 'recompose'
import styled, { keyframes } from 'styled-components'

import CloseButtonSVG from 'assets/icons/white-close.svg'
import { Body } from 'components/Typography'
import { style } from 'theme'

import { TestIDs } from '../../test/utils/testIds'

type Props = {
  handleOnClose?: () => void
  onClose: () => void
  adBlock: boolean
}

const FadeIn = keyframes`
0% {
  bottom: -125px;
  opacity: 0;
}

80% {
  opacity: 1;
}

100% {
  bottom: 0;
  opacity: 1;
}
`

const Container = styled.div<{ adBlock?: boolean }>`
  position: fixed;
  bottom: 0;
  width: 100vw;
  padding: 15px 0px;
  background-color: ${props =>
    props.adBlock
      ? `${style(theme => theme.colors.red)}`
      : `${style(theme => theme.colors.slate)}`};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  opacity: 0;
  animation: ${FadeIn} ease-in 0.5s forwards;
  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    padding: 20px;
  }
`

const CloseButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  right: 40px;
  position: absolute;
  width: 24px;
  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    right: 30px;
  }
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    right: 20px;
    top: 20px;
  }
`
const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    max-width: 335px;
    padding: 0 20px;
    flex-direction: column;
  }
`

const Title = styled(Body)`
  color: #fff;
  font-weight: 600;
  &::after {
    margin: 0 7px;
    content: '—';
  }
  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    line-height: 1.8;
    &::after {
      content: none;
    }
  }
`

const Message = styled(Body)`
  color: #fff;
`

const enhance = compose<Props, Props>(
  withHandlers({
    handleOnClose: ({ onClose }) => () => {
      onClose()
    },
  }),
)

const Toast: React.SFC<Props> = ({ handleOnClose, adBlock }) =>
  adBlock && (
    <Container>
      <TextContainer>
        <Title>Just a heads up</Title>
        <Message>
          Ad blockers may affect how Acorns functions so we highly recommend disabling yours and
          refreshing the page.
        </Message>
      </TextContainer>
      <CloseButton onClick={handleOnClose} data-testid={TestIDs.TOAST.CLOSE_BUTTON}>
        <img src={CloseButtonSVG} alt="Close button" />
      </CloseButton>
    </Container>
  )

export default enhance(Toast)
